export default __webpack_public_path__ + "static/getExtentionLogo-0ba5c0f6f87e3d5d40395d9baa7c419d.svg";